/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export interface MaleWeekTaskTierItem {
  target: number
  /** 档位奖励（网关脱敏自 reward） */
  ack: number
  /** 0 未完成 / 1 待领取 / 2 已领取 */
  status: number
}

/** POST /live/hiya_socialize/f_m_a_w_t → data.week_task；非男主播可空 */
export interface MaleWeekTask {
  /** 本周剩余秒（与 fetch_center_page 同口径） */
  week_remain_ts: number
  /** 结算冲档口径本周进度 */
  stage_v2_week_token_process: number
  /** 最高档目标 */
  max_target: number
  /** 0 未完成 / 1 待领取 / 2 已全部领完 */
  task_status: number
  items?: MaleWeekTaskTierItem[]
  /** 领取接口透传（若后端下发） */
  task_id?: string
  task_level?: string
  task_param?: number
}

/** POST /live/hiya_socialize/f_m_a_w_t → data.room_task；income_scope===2 且非 null 时作为 tab2 */
export interface MaleRoomTask {
  week_remain_ts: number
  week_tokens: number
  max_target: number
  total_ack: number
  receive_ack: number
  /** 0 未完成 / 1 待领取 / 2 已全部领完 */
  task_status: number
  items?: MaleWeekTaskTierItem[]
}

export const union_user_income_info = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/union_user_income_info',
  async (p: any, store: any) => {
    // return {
    //   income: '2123',
    //   union_id: 2345,
    //   union_leader_id: 11212,
    //   verified: false,
    // }
    const resp = await http.post(
      '/live/hiya_socialize/union_user_income_info',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_user_active_stats = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/get_user_active_stats',
  async (p: {time_type: number} = {time_type: 1}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_user_active_stats',
      {
        ...p,
      },
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

export const fetch_male_anchor_week_task = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/fetch_male_anchor_week_task',
  async (_p: Record<string, never>, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/f_m_a_w_t',
      {},
      {
        xcErrorToast: true,
        store,
      }
    )
    return (resp?.data?.data || {}) as {
      week_task?: MaleWeekTask
      room_task?: MaleRoomTask | null
      /** income_scope===2 且有 room_task 时，决定默认停在哪个 tab */
      prefer_room_tab?: boolean
      /** 1 社交全部结算（单进度条 week_task）/ 2 排除语音房（有 room_task 则双进度条） */
      income_scope?: number
    }
  }
)

export type AcquireMaleWeekTaskRewardParams = {
  task_id?: string
  task_type: 'novice_task' | 'daily_task' | 'weekly_task'
  task_level?: string
  task_param?: number
}

/** 原 feat 领取 URL，与女侧一致 */
export const acquire_male_week_task_reward = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/acquire_male_week_task_reward',
  async (params: AcquireMaleWeekTaskRewardParams, store: any) => {
    const resp = await http.post(
      '/live/saada/acquire_f_task_rd',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data || {}
  }
)

export type AcquireRoomTaskRewardResult = {
  err_msg?: string
  list?: {
    level: number
    cfg_require_token: number
    cfg_reward_token: number
  }[]
}

/** 5 acquire_room_task_reward — 领取语音房主播奖励；不要走 acquire_f_task_rd */
export const acquire_room_task_reward = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/acquire_room_task_reward',
  async (_params: Record<string, never>, store: any) => {
    const resp = await http.post(
      '/live/saada/acquire_room_task_reward',
      {},
      {store, xcErrorToast: true}
    )
    return (resp?.data?.data || {}) as AcquireRoomTaskRewardResult
  }
)

/** POST /live/hiya_socialize/g_m_a_i_r_p → data.link */
export const get_male_anchor_income_rules_page = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/get_male_anchor_income_rules_page',
  async (p: Record<string, never> = {}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/g_m_a_i_r_p',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
        store,
      }
    )
    return (resp?.data?.data || {}) as {link?: string}
  }
)

const initialState: {
  home: any
  week_task?: Partial<MaleWeekTask>
  room_task?: Partial<MaleRoomTask> | null
  prefer_room_tab?: boolean
  /** 1 社交全部结算（单进度条 week_task）/ 2 排除语音房（有 room_task 则双进度条） */
  income_scope?: number
  info: Partial<{
    text_stat: {
      online_time: number // 在线时长（单位：秒/分钟，需结合业务确认）
      message_cnt: number // 消息发送总数
      reply_rate_within_2_min: number // 2分钟内回复率（百分比值，如 30 表示 30%）
    }
    voice_call_stat: {
      call_duration: number // 语音通话总时长（单位：分钟/秒）
      call_count: number // 语音通话次数
      avg_call_duration: number // 语音平均通话时长（单位：分钟/秒）
      answer_rate: number // 语音通话接听率（百分比值）
    }
    video_call_stat: {
      call_duration: number // 视频通话总时长（单位：分钟/秒）
      call_count: number // 视频通话次数
      avg_call_duration: number // 视频平均通话时长（单位：分钟/秒）
      answer_rate: number // 视频通话接听率（百分比值）
    }
    room_stat: {
      mic_duration: number // 上麦总时长（单位：分钟/秒）
      open_mic_duration: number // 开麦总时长（单位：分钟）
      effective_live_days: number // 有效开播天数
      enter_room_with_follow_cnt: number // 关注后进入房间的用户数
    }
  }>
} = {
  home: {},
  week_task: undefined,
  room_task: undefined,
  prefer_room_tab: undefined,
  income_scope: undefined,
  info: {},
}

export function useSaadaAnchorGuideCenter() {
  return useSelector((store) => store.SaadaAnchorGuideCenter)
}

export const SaadaAnchorGuideCenterSlice = createSlice({
  name: 'SaadaAnchorGuideCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(union_user_income_info.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
    builder.addCase(get_user_active_stats.fulfilled, (state, action) => {
      Object.assign(state.info, action.payload)
    })
    builder.addCase(fetch_male_anchor_week_task.fulfilled, (state, action) => {
      state.week_task = action.payload?.week_task
      state.room_task = action.payload?.room_task
      state.prefer_room_tab = action.payload?.prefer_room_tab
      state.income_scope = action.payload?.income_scope
    })
  },
})

export default SaadaAnchorGuideCenterSlice.reducer
export const SaadaAnchorGuideCenterActions = SaadaAnchorGuideCenterSlice.actions
